import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { AppType } from '../../types/app.type'
import { IDomainSocIcon, ISocialContact } from '../../types/common.type'
import { Contacts } from '../../types/producer.type'

interface ContactInfo {
  [key: string]: string
}

interface TransformedContact {
  type: string
  url: string
  icon: string
}

@Component({
  selector: 'bmcore-social-icons',
  templateUrl: './bmcore-social-icons.component.html',
  styleUrls: ['./bmcore-social-icons.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreSocialIconsComponent {
  @Input() appType: AppType

  @Input() socialContacts: ISocialContact[] = []
  @Input() BMTVContacts: Contacts

  icons: IDomainSocIcon[] = [
    { type: 'INSTAGRAM', url: '', icon: 'instagram' },
    { type: 'TWITTER', url: '', icon: 'twitter' },
    { type: 'YOUTUBE', url: '', icon: 'btn-youtube' },
    { type: 'VK', url: '', icon: 'vk' },
    { type: 'SOUNDCLOUD', url: '', icon: 'soundcloud' },
    { type: 'FACEBOOK', url: '', icon: 'facebook' },
    { type: 'TWITCH', url: '', icon: 'twitch' },
    { type: 'TIKTOK', url: '', icon: 'tiktok' },
    { type: 'BEATMAKERS.TV', url: '', icon: 'beatmakers-tv' }
  ]

  getIcons() {
    if (this.appType === 'PROD-PAGE') {
      return this.transformContactFromProducerPage()
    } else if (this.appType === 'BMTV') {
      if (this.BMTVContacts) {
        return this.transformContactFromBMTVAdmin(this.BMTVContacts)
      }
    }
    return []
  }

  transformContactFromProducerPage() {
    if (this.socialContacts) {
      for (let i = 0; i < this.icons.length; i++) {
        for (let j = 0; j < this.socialContacts.length; j++) {
          if (this.icons[i].type === this.socialContacts[j].type) {
            this.icons[i].url = this.socialContacts[j].url
          }
        }
      }
      return this.icons.filter(i => i.url)
    }
  }

  transformContactFromBMTVAdmin(contactInfo: ContactInfo): TransformedContact[] {
    const mapping: Record<string, string> = {}
    const shouldShowContact = (contactKey: string) => {
      return contactKey !== 'skype' && contactKey !== 'viber' && contactKey !== 'whatsApp'
    }

    return Object.entries(contactInfo)
      .filter(([key, value]) => value && shouldShowContact(key))
      .map(([key, value]) => {
        const type = key.toUpperCase()
        const icon = mapping[key.toLowerCase()] || key.toLowerCase()
        return { type, url: value, icon }
      })
  }
}
